import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PackageSummaryModal from "../../../Layout/DashboardLayout/Razorpay/PackageSummaryModal";
import RazorpayModal from "../../../Layout/DashboardLayout/Razorpay/RazorpayModal";
import { useRazorpay } from "../../../../context/RazorpayContext";
import PriceSectionCardSkeleton from "../Skeleton/PricingSkeleton";

const PendingPlanSection = ({ currentPlan }) => {
  const { t } = useTranslation();
  const { invoiceModalData, razorpayModalData, handlePreviewPlan, isRazorpayModalTimerLoader, isisPaymentStatus } = useRazorpay();
  const [loading, setLoading] = useState(true);
  const [traceBtnClick, setTraceBtnClick] = useState({
    isLoading: false,
    btnClickPackageId: null,
  });

  const afterPaymentSuccessNavigationUrl = "/dashboard";

  useEffect(() => {
    if (currentPlan) setLoading(false);
  }, [currentPlan]);

  const handlePayNow = (e) =>
    handlePreviewPlan(e, currentPlan?.id, "plan", setTraceBtnClick);


  const formattedDescription = currentPlan?.description
    ?.replace(/\\u003c/g, "<")
    ?.replace(/\\u003e/g, ">")
  // ?.replace(/\n/g, "<br/>");

  const descriptionPoints = formattedDescription
    ?.split("\n")
    ?.filter((line) => line.trim() !== "");

  const heading = isRazorpayModalTimerLoader ? t('pendingPlanSection.processingHeading') : t('pendingPlanSection.heading')
  return (
    <>
      {invoiceModalData?.isInvoiceDetailsModal && (
        <PackageSummaryModal packageType="pendingPayment" currentPlan={currentPlan} />
      )}
      {razorpayModalData?.isRazorPayModal && (
        <RazorpayModal navigationUrl={afterPaymentSuccessNavigationUrl} />
      )}

      <div
        className="min-vh-100 d-flex align-items-center justify-content-center position-relative"
        style={{
          background:
            "linear-gradient(135deg, #e0e7ff 0%, #f9f9ff 30%, #ffffff 100%)",
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 30%, rgba(99, 102, 241, 0.2), transparent 40%), radial-gradient(circle at 80% 70%, rgba(79, 70, 229, 0.15), transparent 40%)",
          }}
        ></div>

        <div className="container position-relative py-5">
          <div className="text-center mb-5">
            <h2 className="fw-bold text-dark mb-2">
              <i className="bi bi-credit-card-fill text-primary me-2"></i>
              {heading}
            </h2>
            <p className="text-muted">
              {t('pendingPlanSection.subHeading')}
            </p>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center">
              <PriceSectionCardSkeleton />
            </div>
          ) : (
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-8">
                <div
                  className="card border-0 shadow-lg rounded-4 p-4 text-center"
                  style={{
                    background:
                      "linear-gradient(180deg, #ffffffcc 0%, #f9f9ffb3 100%)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  {/* Header */}
                  <div className="mb-4">
                    <div className="d-inline-flex align-items-center justify-content-center bg-light rounded-circle shadow-sm p-3 mb-3">
                      <i className="bi bi-box-seam text-primary fs-4"></i>
                    </div>
                    <h4 className="fw-bold text-primary mb-1">
                      {currentPlan?.name}
                    </h4>
                                      {/* Pricing */}
                  <div className="border-top border-bottom py-3 mb-4">
                    <h2 className="fw-bold text-dark mb-0">
                      {currentPlan?.price}
                      <small className="text-muted fs-6">
                        / {currentPlan?.interval}
                      </small>
                    </h2>
                    <span className="text-muted small">  {t('pendingPlanSection.billed')} {currentPlan?.interval}</span>
                  </div>
                    <div className="pending-plan-description">
                      {descriptionPoints?.map((point, i) => {
                        const hasBold = /<b>/i.test(point); // check if <b> tag exists
                        return (
                          <li
                            key={i}
                            style={hasBold ? { listStyleType: "none", paddingLeft: "0" } : {}}
                            dangerouslySetInnerHTML={{ __html: point }}
                          ></li>
                        );
                      })}
                    </div>
                    {/* </p> */}
                  </div>



                  {/* Progress */}
                  <div className="mb-4">
                    <div className="progress" style={{ height: "6px" }}>
                      <div
                        className="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                        style={{ width: "33%" }}
                      ></div>
                    </div>
                    <div className="d-flex justify-content-between mt-1 text-muted small">
                      <span>{t('pendingPlanSection.pending')}</span>
                      <span>{t('pendingPlanSection.active')}</span>
                      <span>{t('pendingPlanSection.payment')}</span>
                    </div>
                  </div>

                  {/* Button */}
                  <div className="mb-4">
                    <button
                      disabled={traceBtnClick?.isLoading}
                      onClick={handlePayNow}
                      className="btn btn-gradient-primary w-100 py-2 rounded-pill fw-semibold shadow-sm"
                      style={{
                        background:
                          "linear-gradient(90deg, #4f46e5 0%, #6366f1 100%)",
                        color: "#fff",
                        border: "none",
                        transition: "0.3s",
                      }}
                      onMouseOver={(e) =>
                      (e.target.style.background =
                        "linear-gradient(90deg, #4338ca 0%, #4f46e5 100%)")
                      }
                      onMouseOut={(e) =>
                      (e.target.style.background =
                        "linear-gradient(90deg, #4f46e5 0%, #6366f1 100%)")
                      }
                    >
                      {((traceBtnClick?.btnClickPackageId === currentPlan?.id) || (isRazorpayModalTimerLoader)) ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                          {t('pendingPlanSection.Processing')}
                        </>
                      ) : (
                        <>
                          <i className="bi bi-arrow-right-circle me-2"></i>
                          {t('pendingPlanSection.ContinuePayment')}
                        </>
                      )}
                    </button>
                  </div>

                  {/* Additional Info */}
                  <div className="alert alert-light border-0 bg-light-subtle text-muted small text-center rounded-3">
                    <i className="bi bi-info-circle me-1 text-primary"></i>
                    {t('pendingPlanSection.additionaly1')}
                    <br />
                    {t('pendingPlanSection.additionaly2')}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PendingPlanSection;

